const styles = (theme) => ({
	titleDataGrid: {
		color: theme.palette.text.primary,
		fontWeight: 500,
		padding: "16px 20px",
		textAlign: "left",
	},
	containerChip: {
		display: "flex",
		flexWrap: "wrap",
		gap: 0.5,
		overflow: "hidden",
	},
	chip: {
		maxWidth: "100%",
		textOverflow: "ellipsis",
		overflow: "hidden",
	},
	// Faixa entre o título e a tabela que aparece só quando a página inteira
	// está marcada — é por ela que se pede a seleção além da página.
	avisoSelecao: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: 1,
		padding: "8px 20px",
		backgroundColor: theme.palette.action.hover,
		borderTop: `1px solid ${theme.palette.divider}`,
		borderBottom: `1px solid ${theme.palette.divider}`,
		textAlign: "center",
	},
	// Faixa do job de importação, entre o título e a tabela.
	avisoImportacao: {
		padding: "10px 20px",
		borderTop: `1px solid ${theme.palette.divider}`,
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	containerPaper: {
		width: "100%",
		borderRadius: "16px",
	},
	boxDatagrid: {
		// A altura vem da própria tabela (Box de altura fixa em volta do
		// DataGrid) — fixar 80vh aqui deixaria um vão morto embaixo do rodapé.
		width: "100%",
		height: "auto",
		overflow: "hidden",
	},
});

export default styles;
